// extracted by mini-css-extract-plugin
module.exports = {"productTitle":"product-title_productTitle__ZxwsT"};